import React from 'react';
import './ErrorSection.css'
import home from '../../assets/home.svg'
import backarrow from '../../assets/back-arrow.svg'
import AmenitiesCon from '../details/AmenitiesCon';

const ErrorSection = () => {
    return ( <>
    <div className='error-container'>
    <h1 className='number4'>404</h1>
    <p className='property'>Property Not Found</p>
    <p className='paragraph'>We couldn't find the property you're looking for. It may have been sold, removed, or the link might be incorrect.</p>
    <div className='button-box'>
    <AmenitiesCon icons={home} text='Back to Home' s3='btn4' />
    <AmenitiesCon icons={backarrow} text='Browse Properties' s3='btn5' />
    </div>
    </div>
    </> );
}
 
export default ErrorSection;